export enum OnlineVideoFilter {
    IS_PLATFORM = "is_platform",
}